import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarCheck, CalendarDays, Clock, CheckCircle2, Users, UserPlus, Music, PartyPopper, Euro, Wallet, Cake } from "lucide-react";
import { api } from "../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [pending, setPending] = useState([]);
  const [birthdays, setBirthdays] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/admin/reservations", { params: { status: "en_attente" } }).then((r) => setPending(r.data.slice(0, 5))).catch(() => {});
    api.get("/admin/birthdays").then((r) => setBirthdays(r.data)).catch(() => {});
  }, []);

  const cards = stats ? [
    { label: "Réservations aujourd'hui", value: stats.today_reservations ?? 0, icon: CalendarDays },
    { label: "Réservations à venir", value: stats.upcoming_reservations ?? 0, icon: CalendarCheck },
    { label: "En attente", value: stats.pending_reservations, icon: Clock },
    { label: "Confirmées", value: stats.confirmed_reservations, icon: CheckCircle2 },
    { label: "Réservations totales", value: stats.total_reservations, icon: CalendarCheck },
    { label: "Clients", value: stats.total_customers, icon: Users },
    { label: "Nouveaux clients (7j)", value: stats.new_customers_7d ?? 0, icon: UserPlus },
    { label: "Revenus (€)", value: stats.revenue?.toFixed(2).replace(".", ",") ?? 0, icon: Euro },
    { label: "Paiements par carte", value: `${stats.card_payment_pct ?? 0}%`, icon: CheckCircle2 },
    { label: "RITAS distribués", value: stats.ritas_distributed ?? 0, icon: Wallet },
    { label: "RITAS utilisés", value: stats.ritas_redeemed ?? 0, icon: Wallet },
    { label: "Soirées publiées", value: stats.published_events, icon: Music },
    { label: "Demandes privées", value: stats.private_requests, icon: PartyPopper },
  ] : [];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif-elegant text-3xl font-bold mb-8">Tableau de bord</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
        {cards.map(({ label, value, icon: Icon }) => (
          <div key={label} className="ic-card !transform-none p-5" data-testid={`stat-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
            <Icon size={18} className="text-[#D4AF37] mb-3" />
            <p className="text-3xl font-semibold">{value}</p>
            <p className="text-xs text-gray-400 mt-1">{label}</p>
          </div>
        ))}
      </div>
      {birthdays.length > 0 && (
        <div className="mb-10" data-testid="dashboard-birthdays">
          <h2 className="font-serif-elegant text-xl font-semibold mb-4 flex items-center gap-2"><Cake size={18} className="text-[#D4AF37]" /> Anniversaires cette semaine</h2>
          <div className="space-y-3">
            {birthdays.map((b) => (
              <div key={b.id} className="ic-card !transform-none p-4 flex flex-wrap justify-between items-center gap-3 text-sm" data-testid={`birthday-${b.id}`}>
                <span className="font-medium">🎂 {b.first_name} {b.last_name}</span>
                <span className="text-[#D4AF37]">{b.days_until === 0 ? "Aujourd'hui !" : b.days_until === 1 ? "Demain" : `Dans ${b.days_until} jours`} ({b.next_birthday})</span>
                <span className="text-gray-400">{b.phone || b.email}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif-elegant text-xl font-semibold">Réservations en attente</h2>
        <Link to="/admin/reservations" className="text-[#D4AF37] text-sm hover:underline">Tout gérer →</Link>
      </div>
      <div className="space-y-3">
        {pending.length === 0 && <p className="text-gray-500 text-sm">Aucune réservation en attente.</p>}
        {pending.map((r) => (
          <div key={r.id} className="ic-card !transform-none p-4 flex flex-wrap justify-between items-center gap-3 text-sm">
            <span className="font-medium">{r.first_name} {r.last_name}</span>
            <span className="text-gray-400">{r.date} · {r.time} · {r.party_size} pers.</span>
            <span className="text-gray-500">{r.phone}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
